import log from 'salvo-lite/log'

class FAQSearch {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._elements = JSON.parse(this._elem.getAttribute('data-faq-search'))
        this._modalElement = document.querySelector(this._elements.modalElement)
        this._searchElement = document.querySelector(this._elements.searchElement)
        this._resultsContainer = document.querySelector(this._elements.resultsContainer)
        this._allResults = [...document.querySelectorAll('[data-faq-search-result]')].map(el => JSON.parse(el.getAttribute('data-faq-search-result')))
        this._inModal = false
        this._modalOpen = false

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this.initModalOpener()

        this.initInputListener()

        this.initModalCloser()
    }

    initModalOpener () {
        this._elem.querySelector('.faq__search').addEventListener('click', () => {
            this._modalElement.classList.add('active')
            this._modalOpen = true

            const activeDropdowns = [...document.querySelectorAll('.faq-toggle')]
            activeDropdowns.forEach(el => {
                if (el.classList.contains('is-active')) {
                    el.click()
                }
            })

            this._searchElement.focus()
        })
    }

    initInputListener () {
        this._searchElement.addEventListener('input', event => {
            this._resultsContainer.innerHTML = ''

            const value = event.target.value.toLowerCase()

            if (value === '') {
                this._modalElement.removeAttribute('style')
                this._resultsContainer.removeAttribute('style')
                return
            }

            const resultsArray = []

            this._allResults.forEach(result => {
                const resultText = `${result.question.toLowerCase()} ${result.answer.toLowerCase()}`
                const resultArray = resultText.split(' ')

                if (resultArray.includes(value)) {
                    resultsArray.push(result)
                }
            })

            if (resultsArray.length) {
                resultsArray.forEach(result => this.buildResult(result))
            } else {
                this._resultsContainer.innerHTML = `
                <div class="search-results__item text-align-center">No results found.</div>
                `
            }
        })
    }

    buildResult (result) {
        document.querySelector('.faq__search-input-box').classList.add('active')

        this._modalElement.style.borderRadius = 'unset'
        this._modalElement.style.borderTopRightRadius = '4px'
        this._modalElement.style.borderTopLeftRadius = '4px'

        this._resultsContainer.style.borderRadius = 'unset'
        this._resultsContainer.style.borderBottomRightRadius = '4px'
        this._resultsContainer.style.borderBottomLeftRadius = '4px'

        const button = document.createElement('button')

        button.classList.add('faq__search-results-item')
        button.innerHTML = result.question

        button.addEventListener('click', () => {
            const element = document.querySelector(result.element)
            const button = element.querySelector('.faq-toggle')
            this.closeModal()
            element.scrollIntoView({ behavior: 'smooth' })
            button.click()
        })

        this._resultsContainer.appendChild(button)
    }

    initModalCloser () {
        this._modalElement.addEventListener('mouseenter', () => {
            this._inModal = true
        })

        this._modalElement.addEventListener('mouseleave', () => {
            this._inModal = false
        })

        this._resultsContainer.addEventListener('mouseenter', () => {
            this._inModal = true
        })

        this._resultsContainer.addEventListener('mouseleave', () => {
            this._inModal = false
        })

        window.addEventListener('click', () => {
            if (this._modalOpen && !this._inModal) {
                this.closeModal()
            }
        })

        window.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                this.closeModal()
            }
        })
    }

    closeModal () {
        setTimeout(() => {
            this._searchElement.blur()
            this._modalElement.classList.remove('active')
            document.querySelector('.faq__search-input').classList.remove('active')
            document.querySelector('.faq__search-input-box').classList.remove('active')
            this._modalElement.removeAttribute('style')
            this._resultsContainer.removeAttribute('style')
            this._searchElement.value = ''
            this._resultsContainer.innerHTML = ''
        }, 100)
    }
}

export default FAQSearch



// WEBPACK FOOTER //
// ./src/resources/scripts/components/FAQSearch.js